<template>
  <div id="variety">
    <v-container grid-list-xl>
      <!-- product header -->
      <base-product-header></base-product-header>

      <!-- all variety  -->
      <v-layout align-center justify-center row v-if="varietyDetails" wrap>
        <v-flex sm6 xs11>
          <div class="headline head-page">{{ `${varietyDetails.length} สายพันธุ์` }}</div>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row wrap>
        <v-flex sm6 xs11>
          <v-layout row wrap>
            <v-flex
              class="mouse-pointer"
              @click="onClickVariety(varietyDetail.varietyid, varietyDetail.varietyname)"
              :key="index"
              lg3
              md3
              pr-1
              sm4
              v-for="(varietyDetail, index) in varietyDetails"
              xs6
            >
              <v-card color="transparent" elevation="0">
                <v-img
                  :aspect-ratio="4 / 4"
                  cover
                  :lazy-src="require('@/assets/NoPicture.png')"
                  :src="
                    varietyDetail.mainpictureurl
                      ? varietyDetail.mainpictureurl
                      : require('@/assets/NoPicture.png')
                  "
                >
                  <template v-slot:placeholder>
                    <v-layout align-center fill-height justify-center ma-0>
                      <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                <v-card-text class="pl-0 pt-2">
                  <div class="body-2">{{ `พันธุ์${varietyDetail.varietyname}` }}</div>
                  <div
                    class="font-weight-light spacing text-uppercase grey--text"
                    style="font-size:0.5em"
                  >{{ `${varietyDetail.varietynameeng || ''}` }}</div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <!-- Content Searchbox -->
      <v-layout align-center justify-center row wrap>
        <v-flex text-xs-center xs12>
          <base-search-bottom-page></base-search-bottom-page>
        </v-flex>
      </v-layout>

      <!-- Banners -->
      <v-layout align-center justify-center row wrap>
        <v-flex sm6 text-xs-center xs11>
          <base-banners bannerPositionId="BANNERPOS0000005" pageId="PAGES0000006"></base-banners>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'variety',
  data() {
    return {}
  },
  computed: {
    productId() {
      return window.atob(this.$route.params.productId)
    },
    varietyDetails() {
      return this.$store.getters['Variety/getVarietyDetails'].map(item => ({
        varietyid: item.varietyid,
        varietyname: item.varietyname,
        varietynameeng: item.varietynameeng,
        mainpictureurl: item.mainpictureurl
      }))
    }
  },
  created() {
    window.scrollTo(0, 0)
  },
  methods: {
    onClickVariety(varietyId) {
      this.$router.push({
        name: 'variety-detail',
        params: {
          productId: window.btoa(this.productId),
          varietyId: window.btoa(varietyId)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
